/*
* @Author: MaYanXia
* @Date:   2020-12-10 09:42:48
 * @Last Modified by: mayanxia
 * @Last Modified time: 2021-06-09 17:47:03
*/
import {isUndefined, isNull} from'@/utils/validate'
/* 前除以100的过滤器 */
const divideMoneyBy100Filter = (data) => {
    if(isUndefined(data)||isNull(data)||data==='') {
        return ''
    }
    return parseInt(data)/100
}
export  {divideMoneyBy100Filter}
